import { render, staticRenderFns } from "./Temperatura.vue?vue&type=template&id=4cc72358&scoped=true&"
import script from "./Temperatura.vue?vue&type=script&lang=ts&"
export * from "./Temperatura.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc72358",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4cc72358', component.options)
    } else {
      api.reload('4cc72358', component.options)
    }
    module.hot.accept("./Temperatura.vue?vue&type=template&id=4cc72358&scoped=true&", function () {
      api.rerender('4cc72358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/TiposdeInformes/TipoTemperatura/Temperatura.vue"
export default component.exports